import averageAnalysis from "./index.vue";
import averageAnalysisHome from "./Home.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const simpleAverageData = () => import("./../../components/SimpleAverageData");
const login = () => import("./login.vue");

export default [
  {
    path: "/averageAnalysisIndex",
    name: "averageAnalysisIndex",
    component: averageAnalysisHome,
  },
  {
    path: "/averageAnalysis/login",
    name: "averageAnalysisLogin",
    component: login,
  },
  {
    path: "/averageAnalysis",
    name: "averageAnalysis",
    redirect: "/averageAnalysis",
    component: averageAnalysis,
    children: [
      {
        path: "simpleAverageData",
        name: "simpleAverageData",
        component: simpleAverageData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory,
      },
    ],
  },
];
